var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
		`btn btn-circle btn-${_vm.outlineClass}${_vm.color} ${_vm.className}`,
		{ 'btn-circle-title' : _vm.withTitle },
		_vm.customClass
	],attrs:{"id":_vm.id,"title":_vm.titleData,"disabled":_vm.disabled,"type":"button","data-toggle":_vm.dataToggle,"data-content":_vm.dataContent},on:{"click":_vm.callback}},[_c('i',{class:'fa fa-' + _vm.icon}),_vm._v(" "),_c('span',{class:{ 'd-none': true, 'd-lg-inline-block': _vm.withTitle }},[_vm._v("\n\t\t"+_vm._s(_vm.titleData)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }